// Generated by CoffeeScript 1.12.7
(function () {
  Viewthespace.Spinner = (function () {
    Spinner.start = function () {
      return new Viewthespace.Spinner($("#spinner")).start();
    };

    Spinner.stop = function () {
      return new Viewthespace.Spinner($("#spinner")).stop();
    };

    function Spinner($elements, options) {
      this.$elements = $elements;
      this.options = options != null ? options : {};
    }

    Spinner.prototype.start = function () {
      return this.$elements.spin(this._settings());
    };

    Spinner.prototype.stop = function () {
      return this.$elements.spin(false);
    };

    Spinner.prototype._settings = function () {
      return jQuery.extend(
        {
          lines: 13,
          length: 5,
          width: 2,
          radius: 9,
          corners: 1,
          rotate: 0,
          direction: 1,
          color: "#000",
          speed: 1.3,
          trail: 48,
          shadow: true,
          hwaccel: false,
          className: "spinner",
          zIndex: 2e9,
          top: "auto",
          left: "auto",
        },
        this.options
      );
    };

    return Spinner;
  })();
}.call(this));
